import axios from 'axios';

const dnaBaseUrl = process.env.VUE_APP_DNA_API_BASE_URL;

// a variable for storing all the GET requests that are in-progress
// so we can efficiently handle multiple requests (identical requests
// return simply the first request made if the first is still in-progress)
const inProgressGetRequests = {};
export default {
  axios: axios.create({
    baseURL: dnaBaseUrl
  }),

  /**
   * Returns the default axios config for the api
   * @returns {AxiosRequestConfig|Object}
   */
  getDefaultConfig() {
    return { headers: this.getRequestAuthHeaders() };
  },

  /**
   * Returns the auth header with bearer token for the itovi api
   * @returns {Object}
   */
  getRequestAuthHeaders() {
    const token = process.env.VUE_APP_DNA_API_KEY;
    return { 'Authorization': `Token ${token}` }
  },

  /**
   * Returns the response from the api
   * @param {string} url
   * @param {AxiosRequestConfig?} config
   * @returns {Promise<AxiosResponse>} the response of the request
   */
  get(url, config) {
    // if a GET request is made while an identical GET request is still in-progress,
    // just return the first
    if (inProgressGetRequests[url] == null) { inProgressGetRequests[url] = this.axios.get(url, config) }
    inProgressGetRequests[url].then(() => { inProgressGetRequests[url] = null }).catch(() => { inProgressGetRequests[url] = null });
    return inProgressGetRequests[url]
  },
  /**
   * Returns the response from the api
   * @param {string} url
   * @param {Object?} data an object containing the POST body
   * @param {AxiosRequestConfig?} config
   * @returns {Promise<AxiosResponse>} the response of the request
   */
  post(url, data, config) {
    return this.axios.post(url, data, config)
  },
  /**
   * Returns the response from the api
   * @param {string} url
   * @param {Object?} data an object containing the PATCH body
   * @param {AxiosRequestConfig?} config
   * @returns {Promise<AxiosResponse>} the response of the request
   */
  patch(url, data, config) {
    return this.axios.patch(url, data, config)
  },
  /**
   * Returns the response from the api
   * @param {string} url
   * @param {Object?} data an object containing the PUT body
   * @param {AxiosRequestConfig?} config
   * @returns {Promise<AxiosResponse>} the response of the request
   */
  put(url, data, config) {
    return this.axios.put(url, data, config)
  },
  /**
   * Returns the response from the api
   * @param {string} url
   * @param {AxiosRequestConfig?} config
   * @returns {Promise<AxiosResponse>} the response of the request
   */
  delete(url,config) {
    return this.axios.delete(url, config)
  },
};
